import {
  API_URL,
  store
} from '../index'
import axios from 'axios/index'

/* import error handler */
import ErrorHandler from '../ErrorHandler'
import SuccessHandler from '../SuccessHandler'

/* private VatSettings Types */
import {
  Settings,
  _VatSettings
} from '../namespace-helper'

import _ from 'lodash'

const selectedVatTemplate = {
  id: 0,
  name: '',
  value: 0
}

export default {
  namespaced: true,
  state: {
    vats: [],
    allVats: [],
    selectedVat: _.cloneDeep(selectedVatTemplate),
    addEditDialogState: false
  },
  mutations: {
    [_VatSettings.mutations.setVats] (state, payload) {
      state.vats = payload
    },
    [_VatSettings.mutations.setAllVats] (state, payload) {
      state.allVats = payload
    },
    [_VatSettings.mutations.setSelectedVat] (state, payload) {
      if (payload !== null) {
        state.selectedProduct = payload
      } else {
        state.selectedProduct = _.cloneDeep(selectedVatTemplate)
      }
    },
    [_VatSettings.mutations.setDialogState] (state) {
      state.addEditDialogState = !state.addEditDialogState
    }
  },
  actions: {
    [_VatSettings.actions.saveProduct] (context, payload) {
      store.commit(Settings.mutations.setLoading, true)

      const data = JSON.stringify(payload)

      if (payload.id === 0) {
        var url = API_URL + '/api/v1/vats'

        axios.post(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_VatSettings.mutations.setSelectedVat, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      } else {
        url = API_URL + '/api/v1/vats/' + payload.id

        axios.put(url, data, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + store.getters.getBearerToken
          }
        }
        ).then(function (r) {
          store.commit(Settings.mutations.setLoading, false)
          ErrorHandler.clear(store)
          context.commit(_VatSettings.mutations.setSelectedVat, r.data.data)
          SuccessHandler.handleApiSuccess(store, r.data.message)
        }, function (err) {
          ErrorHandler.handleApiError(store, err)
        }).catch(e => console.error('#### ' + e))
      }
    },
    [_VatSettings.actions.loadVats] (context, payload) {
      console.log('loadVats: ' + JSON.stringify(payload))
      console.log('loadVats: ' + payload.sortBy + ' ' + payload.descending + ' ' + payload.page + ' ' + payload.limit)

      var url = API_URL + '/api/v1/vats?limit=' + payload.limit + '&page=' + payload.page + '&search=' + payload.search + '&searchFields=id:like;name:like;email:like;website:like&orderBy=' + payload.sortBy + '&sortedBy=' + payload.descending

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_VatSettings.mutations.setVats, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_VatSettings.actions.loadAllVats] (context, payload) {
      console.log('loadAllVats: ' + JSON.stringify(payload))

      var url = API_URL + '/api/v1/vats'

      store.commit(Settings.mutations.setLoading, true)

      return axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + store.getters.getBearerToken
        }
      }
      ).then(function (r) {
        store.commit(Settings.mutations.setLoading, false)
        ErrorHandler.clear(store)
        context.commit(_VatSettings.mutations.setAllVats, r.data.data)
      }, function (err) {
        ErrorHandler.handleApiError(store, err)
      }).catch(e => console.error('#### ' + e))
    },
    [_VatSettings.actions.openCloseDialog] ({ commit }) {
      commit(_VatSettings.mutations.setDialogState)
    },
    [_VatSettings.actions.setSelectedVat] ({ commit }, payload) {
      commit(_VatSettings.mutations.setSelectedVat, payload)
    },
    [_VatSettings.actions.resetState] ({ commit }, payload) {
      commit(_VatSettings.mutations.setVats, [])
      commit(_VatSettings.mutations.setAllVats, [])
      commit(_VatSettings.mutations.setSelectedVat, null)
    }
  },
  getters: {
    [_VatSettings.getters.vats] (state) {
      return state.products
    },
    [_VatSettings.getters.getAllVats] (state) {
      return state.allVats
    },
    [_VatSettings.getters.getDialogState] (state) {
      return state.addEditDialogState
    },
    [_VatSettings.getters.getSelectedVat] (state) {
      return state.selectedVat
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Settings/vats.js